import { render, staticRenderFns } from "./ZonasModalNuevo.vue?vue&type=template&id=74d44fe1&scoped=true&"
import script from "./ZonasModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ZonasModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ZonasModalNuevo.vue?vue&type=style&index=0&id=74d44fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d44fe1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74d44fe1', component.options)
    } else {
      api.reload('74d44fe1', component.options)
    }
    module.hot.accept("./ZonasModalNuevo.vue?vue&type=template&id=74d44fe1&scoped=true&", function () {
      api.rerender('74d44fe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/ZonasModalNuevo.vue"
export default component.exports